/**
 * API Endpoints Configuration
 * Centralized definition of all API endpoints
 */

export const API_ENDPOINTS = {
  // ============================================================================
  // Authentication
  // ============================================================================
  auth: {
    login: '/api/users/login',
    register: '/api/users/createAccount',
    logout: '/api/users/logout',
    validate: '/api/users/validate',
    passwordRecovery: '/api/users/recoverPassword',
    passwordReset: '/api/users/resetPassword',
    profile: '/api/users/profileInformation',
  },

  // ============================================================================
  // Users
  // ============================================================================
  users: {
    base: '/api/users',
    byId: (id: string) => `/api/users/${id}`,
    profile: '/api/users/profileInformation',
    updateProfile: '/api/users/profile',
    // Validation endpoints
    getBotContact: '/api/users/getBotContact',
    validationStatus: '/api/users/validationStatus',
    validationCode: '/api/users/me/validation-code',
    updateAccountInformation: '/api/users/updateAccountInformation',
  },

  // ============================================================================
  // Professionals
  // ============================================================================
  professionals: {
    base: '/api/professionals',
    byId: (id: string) => `/api/professionals/${id}`,
    byUserId: (userId: string) => `/api/professionals/professionalProfile/${userId}`,
    currentProfile: '/api/professionals/professionalInformation',
    create: '/api/professionals',
    update: (id: string) => `/api/professionals/${id}`,
    updateCurrent: '/api/professionals/updateProfessionalInformation',
    deactivate: (id: string) => `/api/professionals/${id}/deactivateAccount`,
    deactivateCurrent: '/api/professionals/deactivateAccount',
    delete: (id: string) => `/api/professionals/${id}/deactivateAccount`, // Soft delete via deactivate
    contactNumber: (id: string) => `/api/professionals/contactNumber/${id}`,
  },

  // ============================================================================
  // Professions
  // ============================================================================
  professions: {
    base: '/api/professions',
    byId: (id: string) => `/api/professions/${id}`,
    professionals: (professionId: string) => `/api/professions/${professionId}/professionals`,
  },

  // ============================================================================
  // Locations
  // ============================================================================
  locations: {
    cities: '/api/locations/cities',
    cityById: (id: string) => `/api/locations/cities/${id}`,
    provinces: '/api/locations/provinces',
  },

  // ============================================================================
  // Reviews
  // ============================================================================
  reviews: {
    base: '/api/jobsreviews',
    byId: (id: string) => `/api/jobsreviews/${id}`,
    byProfessional: (professionalId: string) => `/api/jobsreviews/professional/${professionalId}`,
    create: '/api/jobsreviews',
    update: (id: string) => `/api/jobsreviews/${id}`,
    delete: (id: string) => `/api/jobsreviews/${id}`,
  },
}
